export function getDelay(backoffDelay, maxInterval) {
    return Math.min(backoffDelay, maxInterval);
}
export function exponentialBackoffDelay(iteration, initialInterval) {
    return Math.pow(2, iteration) * initialInterval;
}
